export const jobLabelsMap = {
  SIMULATION_RUN: 'Simulation',
  MESH_OPERATION: 'Mesh operation',
  GEOMETRY_OPERATION: 'Geometry operation'
}

export interface JobsResponseItem {
  [key: string]: any
  jobUuid: string
  resultUuid: string
  jobType: string
  progress: number
  runningStatus: string
  duration: string
  computingTime: string
  toolType: string
}

export interface JobsResponseResultItem {
  uuid: string
}

export interface JobsResponse {
  jobs: JobsResponseItem[]
  results: JobsResponseResultItem[]
}

export interface JobItem {
  key: string
  status: string
  progress: number
  jobTypeLabel: string
  durationMinutes: string
  coreHours: string
}
